import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

// Shown in place of the testimonials until real customer reviews are added to data/testimonials.ts
const benefits = [{
  title: 'Clear visual explanations',
  text: 'Make machine settings, body measurements, pattern drafting and construction steps easy to explain and easy for students to remember.'
}, {
  title: 'Six organized volumes',
  text: '300 visual training pages across every core sewing and pattern-making teaching area, so class prep takes minutes instead of hours.'
}, {
  title: 'Precision built in',
  text: 'Exact seam allowances in inches and centimeters, step-by-step sequences and ❌/✅ comparisons that reinforce correct, clean technique.'
}, {
  title: 'Ready-to-use drills & assessments',
  text: 'Studio drills, practice samples, project banks, quick checks and competency rubrics that keep students engaged and progressing.'
}];
export function InstructorBenefits() {
  return <section className="py-12 bg-[#F8F3EC] border-y border-[#E6D5BF]" data-id="element-174" data-mp="1jkr93pl1vzho">
      <div className="max-w-7xl mx-auto px-4" data-id="element-175" data-mp="1eleq5fxavckd">
        <div className="text-center mb-7" data-id="element-176" data-mp="1empt5dix8gaf">
          <h2 className="text-[#520128] font-bold tracking-widest uppercase text-sm" data-id="element-177" data-mp="1sl5vytdnxmna">
            Why Sewing Instructors Choose This Atlas
          </h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-178" data-mp="1olf9h1v65sok">
          {benefits.map((benefit, index) => <motion.article key={benefit.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-[#E6D5BF] p-6 rounded-2xl shadow-sm shadow-[#520128]/5 flex flex-col" data-id="element-179" data-mp="1xjr033w1cqh0" data-mpi={index}>
              <CheckCircle2 size={22} className="text-green-600 mb-3" aria-hidden="true" data-id="element-180" data-mp="2gb06v5ef914w" />
              <h3 className="font-bold text-[#520128] text-base mb-2" data-id="element-181" data-mp="1dxcf5pmys81j">{benefit.title}</h3>
              <p className="text-slate-700 text-sm leading-relaxed" data-id="element-182" data-mp="1ivnntx1iwci6">{benefit.text}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}